import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
export function EditProfileCustomFields() {
  const navigate = useNavigate();
  return <div className="space-y-4" data-id="element-788">
      <div className="flex items-center justify-between" data-id="element-789">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-790">
          Edit My Profile Custom Fields:
        </h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/admin-area')} data-id="element-791">
          ← Back to Admin Area
        </Button>
      </div>
      <Card data-id="element-792">
        <CardContent className="pt-6" data-id="element-793">
          <form className="space-y-4 max-w-md" data-id="element-794">
            <div className="flex items-center gap-3" data-id="element-795">
              <label className="text-sm font-medium text-slate-700 w-24" data-id="element-796">
                Select Field
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 w-20" data-id="element-797">
                <option data-id="element-798">1</option>
                <option data-id="element-799">2</option>
                <option data-id="element-800">3</option>
              </select>
            </div>
            <div className="flex items-center gap-4" data-id="element-801">
              <label className="text-sm font-medium text-slate-700 w-24" data-id="element-802">
                Select Field Type
              </label>
              <div className="flex items-center gap-4" data-id="element-803">
                <label className="flex items-center gap-1.5 cursor-pointer" data-id="element-804">
                  <input type="radio" name="fieldType" value="text" defaultChecked className="focus:ring-slate-400" data-id="element-805" />
                  <span className="text-sm text-slate-700" data-id="element-806">Text Field</span>
                </label>
                <label className="flex items-center gap-1.5 cursor-pointer" data-id="element-807">
                  <input type="radio" name="fieldType" value="dropdown" className="focus:ring-slate-400" data-id="element-808" />
                  <span className="text-sm text-slate-700" data-id="element-809">Drop Down</span>
                </label>
              </div>
            </div>
            <div data-id="element-810">
              <input type="text" defaultValue="are you on facebook?" className="h-8 w-full max-w-xs rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400" data-id="element-811" />
            </div>
            <div className="flex items-center gap-2" data-id="element-812">
              <input type="checkbox" id="required" className="rounded border-slate-300 focus:ring-slate-400" data-id="element-813" />
              <label htmlFor="required" className="text-sm text-slate-700" data-id="element-814">
                Required
              </label>
            </div>
            <div className="pt-2" data-id="element-815">
              <Button type="submit" data-id="element-816">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}